import { useEffect } from "react";
import { toast } from "react-toastify";

const NetworkStatusNotifier = () => {
  useEffect(() => {
    const handleOnline = () => {
      toast.dismiss(); // Dismiss any existing offline toast
      toast.success("You're back online!", {
        type: "success",
      });
    };

    const handleOffline = () => {
      toast.dismiss(); // Dismiss any existing online toast
      toast.error("You're offline. Check your connection!", {
        autoClose: false,
      });
    };

    // Add event listeners
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Check the initial network status
    if (!navigator.onLine) {
      handleOffline();
    }

    // Cleanup event listeners on unmount
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default NetworkStatusNotifier;
